// import React from 'react';
// import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
// import { Home, List, AccountBalance, AccountCircle } from '@mui/icons-material';
// import { useNavigate, useLocation } from 'react-router-dom';

// function NavBar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [value, setValue] = React.useState(location.pathname);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//     navigate(newValue);
//   };

//   return (
//     <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
//       <BottomNavigation value={value} onChange={handleChange}>
//         <BottomNavigationAction label="Watchlist" value="/" icon={<Home />} />
//         <BottomNavigationAction label="Trades" value="/trades" icon={<List />} />
//         <BottomNavigationAction label="Portfolio" value="/portfolio" icon={<AccountBalance />} />
//         <BottomNavigationAction label="Profile" value="/profile" icon={<AccountCircle />} />
//       </BottomNavigation>
//     </Paper>
//   );
// }

// export default NavBar;


import React, { useEffect, useState, useContext, useCallback } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Box, Typography, Divider } from '@mui/material';
import { 
  TrendingUp, 
  TrendingDown, 
  Assessment, 
  AccountBalance, 
  History,
  ExpandMore,
  ExpandLess
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { WebSocketContext } from '../WebSocketContext';
import './NavBar.css'; // Import custom CSS file
import BottomTime from './BottomTime';
import config from '../config';

function NavBar() {
  const { isDarkMode } = useTheme();
  const { userDetails } = useContext(WebSocketContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(location.pathname);

  // Pages where bottom navigation should be shown
  const allowedPages = ['/', '/trades', '/net-positions'];
  
  // Check if current page should show bottom navigation
  const shouldShowNavBar = allowedPages.includes(location.pathname);
  const [marqueeText, setMarqueeText] = useState(null);
  const [showMarginBox, setShowMarginBox] = useState(false);
  
  // Animation states
  const [moving, setMoving] = useState(false);
  const [selected, setSelected] = useState(1);
  const [prev, setPrev] = useState(selected);
  const [mid, setMid] = useState("");

  const getTodayScrollText = async () => {
      try 
      {  
        const response = await fetch(`${config.API_BASE_URL}getTodayScrollText`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d` // Ensure this is stored securely
          },
          body: JSON.stringify({ }),
        });
        
        const data = await response.json();
        
        setMarqueeText(data.text); 

      } catch (error) {
        console.error('Error fetching marquee text:', error);
      }
  };

  useEffect(() => {
    getTodayScrollText();
  }, []);

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  const toggleMarginBox = () => {
    setShowMarginBox(!showMarginBox);
  };

  // Navigation items configuration
  const navItems = [
    { 
      key: 'quotes', 
      title: 'Quotes', 
      path: '/', 
      icon: <TrendingUp />, 
      index: 1 
    },
    { 
      key: 'trades', 
      title: 'Trades', 
      path: '/trades', 
      icon: <Assessment />, 
      index: 2 
    },
    { 
      key: 'net-positions', 
      title: 'Portfolio', 
      path: '/net-positions', 
      icon: <AccountBalance />, 
      index: 3 
    },
    // { 
    //   key: 'portfolio', 
    //   title: 'Portfolio', 
    //   path: '/portfolio', 
    //   icon: <AccountBalance />, 
    //   index: 3 
    // },
    // { 
    //   key: 'performance', 
    //   title: 'Performance', 
    //   path: '/performance', 
    //   icon: <History />, 
    //   index: 4 
    // }
  ];

  // Get current selected index based on pathname
  const getCurrentIndex = useCallback(() => {
    const currentItem = navItems.find(item => item.path === location.pathname);
    return currentItem ? currentItem.index : 1;
  }, [location.pathname]);

  // Update selected when location changes
  useEffect(() => {
    const currentIndex = getCurrentIndex();
    setSelected(currentIndex);
  }, [getCurrentIndex]);

  // Animated click handler
  const onNavClick = useCallback((index, path, isSpecial) => (event) => {
    event.preventDefault();
    event.persist();
    
    if (isSpecial) {
      toggleMarginBox();
      return;
    }
    
    setPrev(selected);
    setSelected(index);
    setMid("initialised");
    setMoving(true);
    
    // Navigate after animation starts
    if (path) {
      navigate(path);
    }
    
    setTimeout(() => {
      setMoving(false);
      setMid("");
    }, 750);
  }, [selected, navigate, toggleMarginBox]);

  const selectedTab = useCallback((index) => {
    return selected === index ? "initialised" : "";
  }, [selected]);

  // Don't render if current page is not in allowed pages
  if (!shouldShowNavBar) {
    return null;
  }

  return (
    <div className={`bottom-navigation ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      {/* Margin Box */}
      {showMarginBox && (
        <div className="margin-box">
          <div className="margin-box-header">
            <Typography variant="h6" className="margin-box-title">Account Summary</Typography>
            <button className="margin-box-close" onClick={toggleMarginBox}>
              <ExpandMore />
            </button>
          </div>
          <div className="margin-box-content">
            <div className="margin-row">
              <span className="margin-label">Balance:</span>
              <span className={`margin-value ${userDetails?.mainAmount < 0 ? 'negative' : 'positive'}`}>
                ₹{Number(userDetails?.mainAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div>
            {/* <div className="margin-row">
              <span className="margin-label">Floating P&L:</span>
              <span className={`margin-value ${userDetails?.floatingPL < 0 ? 'negative' : 'positive'}`}>
                ₹{Number(userDetails?.floatingPL || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            <div className="margin-row">
              <span className="margin-label">Used Margin:</span>
              <span className="margin-value positive">
                ₹{Number((userDetails?.mainAmount - userDetails?.availableMargin) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div>
            {/* <div className="margin-row">
              <span className="margin-label">Assets Value:</span>
              <span className={`margin-value ${userDetails?.assetsValue < 0 ? 'negative' : 'positive'}`}>
                ₹{Number(userDetails?.assetsValue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            {/* <Divider className="margin-divider" /> */}
            <div className="margin-row">
              <span className="margin-label">Free Margin:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.availableMargin || 0).toLocaleString('en-IN', { minimumFractionDigits: 1 })}
              </span>
            </div>
            {/* <div className="margin-row">
              <span className="margin-label">Equity:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.equity || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Holding Margin:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.holdingMargin || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Credit:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.credit || 0).toLocaleString('en-IN', { minimumFractionDigits: 0 })}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Account:</span>
              <span className="margin-value positive">
                {userDetails?.accountNumber || 'N/A'}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Margin Level:</span>
              <span className="margin-value positive">
                {Number(userDetails?.marginLevel || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}%
              </span>
            </div> */}
          </div>
        </div>
      )}

      <nav className={`tab ${moving ? 'moving' : ''}`} data-selected={selected}>
        <div className="icons">
          {navItems.map((item) => (
            <div 
              key={item.key}
              data-index={item.index} 
              className={`icon ${selectedTab(item.index)} ${item.isSpecial ? 'special' : ''}`} 
              onClick={onNavClick(item.index, item.path, item.isSpecial)}
            >
              <div className="nav-icon">
                {item.icon}
              </div>
              <span className="nav-label">{item.title}</span>
            </div>
          ))}
        </div>
        <div className="bar">
          <div className="cap" />
          <div className="middle">
            <div className="side" />
            <div className="circle" />
            <div className="side" />
          </div>
          <div className="cap" />
        </div>
      </nav>
      {/* <marquee className="nav-marquee">
        {marqueeText}
      </marquee>
      <BottomTime /> */}
    </div>
  );
}

export default NavBar;

